/**
 * Normalises a menu/router path before it is compared or registered.
 * Query, hash and whitespace are intentionally rejected because this utility
 * represents route records rather than a full browser location.
 */
export function normaliseRoutePath(value) {
  if (typeof value !== "string") {
    return "";
  }

  const path = value.trim();
  if (!path || path.charAt(0) !== "/" || /[?#\s]/.test(path)) {
    return "";
  }

  return path.length > 1 ? path.replace(/\/+$/, "") : path;
}

export default normaliseRoutePath;
